import styled from 'styled-components';

import { Button } from '@calm-web/design-system';

export const SubmitButton = styled(Button)`
	margin-top: 1rem;
`;
